/**
 * Utility functions for handling order statuses (tenantStatus / tenantBranchStatus).
 */

export const ALL_STATUSES = [
  { value: "PENDING_PICKING", label: "ממתין לליקוט" },
  { value: "ROBOT_PICKING", label: "בליקוט רובוט" },
  { value: "MANUAL_PICKING", label: "בליקוט ידני" },
  { value: "ROBOT_PICKING_DONE", label: "ליקוט רובוט הושלם" },
  { value: "MANUAL_PICKING_DONE", label: "ליקוט ידני הושלם" },
  { value: "MANUAL_PICKING_SHORT_PICKED", label: "ליקוט ידני - לוקט חלקית" },
  { value: "MANUAL_PICKING_PAYMENT_FAILED", label: "ליקוט ידני - תשלום נכשל" },
  { value: "PENDING_COMPLETION", label: "ממתין להשלמה" },
  { value: "DELIVERED", label: "נמסר" },
  { value: "RETURNED", label: "הוחזר" },
  { value: "CANCELED_OR_NOT_RELEVANT", label: "בוטל / לא רלוונטי" },
];

export const getStatusText = (status) => {
  if (!status) return "סטטוס לא ידוע";
  const s = status.trim().toUpperCase();

  if (s.includes("MANUAL_PICKING_SHORT_PICKED"))
    return "ליקוט ידני - לוקט חלקית";
  if (s.includes("MANUAL_PICKING_PAYMENT_FAILED"))
    return "ליקוט ידני - תשלום נכשל";
  if (s.includes("MANUAL_PICKING_DONE")) return "ליקוט ידני הושלם";
  if (s.includes("MANUAL_PICKING")) return "בליקוט ידני";
  if (s.includes("ROBOT_PICKING_DONE")) return "ליקוט רובוט הושלם";
  if (s.includes("ROBOT_PICKING")) return "בליקוט רובוט";
  if (s.includes("PENDING_PICKING")) return "ממתין לליקוט";
  if (s.includes("PENDING_COMPLETION")) return "ממתין להשלמה";
  if (s.includes("CANCELED_OR_NOT_RELEVANT")) return "בוטל / לא רלוונטי";
  if (s.includes("DELIVERED")) return "נמסר";
  if (s.includes("RETURNED")) return "הוחזר";
  if (s.includes("CREATED")) return "ממתין לליקוט";
  if (s.includes("CLOSED")) return "הזמנה סגורה";
  if (s.includes("DEMAND")) return "בליקוט רובוט";

  return status;
};

export const getStatusClass = (status) => {
  if (!status) return "status-default";
  const s = status.toUpperCase();

  if (s.includes("DELIVERED")) return "status-ready";
  if (s.includes("CLOSED")) return "status-ready";
  if (s.includes("RETURNED")) return "status-demand";
  if (s.includes("CANCELED_OR_NOT_RELEVANT")) return "status-demand";
  if (s.includes("MANUAL_PICKING_PAYMENT_FAILED")) return "status-demand";
  if (s.includes("MANUAL_PICKING_SHORT_PICKED")) return "status-demand";
  if (s.includes("MANUAL_PICKING_DONE")) return "status-ready";
  if (s.includes("ROBOT_PICKING_DONE")) return "status-ready";
  if (s.includes("MANUAL_PICKING")) return "status-demand";
  if (s.includes("ROBOT_PICKING")) return "status-demand";
  if (s.includes("DEMAND")) return "status-demand";
  if (s.includes("CREATED")) return "status-done";
  if (s.includes("PENDING_PICKING")) return "status-done";
  if (s.includes("PENDING_COMPLETION")) return "status-done";
  return "status-default";
};
